export default __webpack_public_path__ + "images/W6.3f43055.png";